import React from 'react' //   } //   //  useEffect //   // useState, //   // useMemo, // , {
import { useHistory, useLocation } from 'react-router-dom'
import { makeStyles, Tab, Box } from '@material-ui/core'
import PaymentTutorial from 'src/mobile/pages/PaymentTutorial'
import { ReactComponent as ViewAllIcon } from 'src/mobile/assets/icons/Home_all.svg'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'
import { ReactComponent as Suona } from 'src/mobile/assets/icons/suona.svg'
import { useTranslation } from 'react-i18next'
import translationHK from 'src/assets/locales/zh-HK/translation.json'
import { buttonClick, articleClick } from 'src/utils/trackingCode'

const useStyles = makeStyles((theme) => ({
  root: {},
  tabList: {
    '& .MuiTabs-indicator': {
      backgroundColor: '#F2512D',
    },
    '& .MuiTab-wrapper': {
      fontWeight: 600,
    },
    '& .MuiTab-textColorInherit': {
      fontSize: 16,
    },
    borderBottom: '1px solid #E5E7EB',
  },
  PromotionContainer: {
    cursor: 'pointer',
    lineHeight: '150%',
    fontWeight: 600,
    fontSize: 14,
    margin: '0 auto',
  },
  viewAllbtn: {
    width: theme.spacing(42.75),
    height: theme.spacing(7),
    background: theme.palette.secondary.main,
    borderRadius: theme.spacing(1),
    padding: '16px 24px',
    textAlign: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: theme.spacing(2),
    fontWeight: 600,
    marginBottom: theme.spacing(8),
    display: 'flex',
    cursor: 'pointer',
  },
  viewAllbtnIcon: {
    marginTop: theme.spacing(0.4),
    marginLeft: theme.spacing(1),
  },
  PromotionBox: {
    fontSize: 14,
    marginTop: theme.spacing(1),
    color: '#F57457',
    display: 'flex',
  },
  PromotionTitle: {
    marginTop: theme.spacing(1),
    lineHeight: '150%',
    marginBottom: theme.spacing(1),
  },
  PromotionTime: {
    color: '#9CA3AF',
    marginBottom: theme.spacing(4),
  },
  imgstyle: {
    borderRadius: 8,
  },
}))

import { useImageTranslation } from 'src/hooks'

const Promotion = () => {
  const history = useHistory()
  const classes = useStyles()
  const { t } = useTranslation()
  const [tImage] = useImageTranslation()
  const location = useLocation()
  const [value, setValue] = React.useState(location?.state?.value || '1')
  const handleChange = (event, newValue) => {
    const buttonName = newValue === '1' ? 'EH_Promo_AllPromos_Tab' : 'EH_Promo_CodeUsage_Tab'
    const buttonId = newValue === '1' ? 'EH_Promo_AllPromos_Tab' : 'EH_Promo_CodeUsage_Tab'
    buttonClick(buttonName, buttonId)
    setValue(newValue)
  }
  const AllPromotion = () => {
    const PromotionList = [
      {
        path: `/promotions_NEW330`,
        promotionSrc: tImage('program_banner', 'webp'),
        text: t('promotion.Healthcheck'),
        time: '21.02.2023',
        content_title: translationHK?.promotion?.Healthcheck,
      },
      // {
      //   path: `/agreement/${
      //     process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 16 : 8
      //   }`,
      //   promotionSrc: tImage('Banner2_revamp', 'webp'),
      //   text:t('promotion.atome_offers'),
      //   time:"19.02.2023"
      // },
      // {
      //   path: `/agreement/${
      //     process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 16 : 8
      //   }`,
      //   promotionSrc: tImage('Promotion_img', 'webp'),
      //   text: t('promotion.first_offers'),
      //   time: '30.07.2023',
      //   content_title: translationHK?.promotion?.first_offers
      // },
      // {
      //   path: `/agreement/${
      //     process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 16 : 8
      //   }`,
      //   promotionSrc: tImage('Promotion_img2', 'webp'),
      //   text: t('promotion.summer_sales'),
      //   time: '22.05.2023',
      //   content_title: translationHK?.promotion?.summer_sales
      // },
      // {
      //   path: `/agreement/${
      //     process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 16 : 8
      //   }`,
      //   promotionSrc: tImage('Promotion_img2', 'webp'),
      //   text: t('promotion.summer_sales'),
      //   time: '22.05.2023',
      //   content_title: translationHK?.promotion?.summer_sales
      // },
      // {
      //   path: `/agreement/${
      //     process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development' ? 16 : 8
      //   }`,
      //   promotionSrc: tImage('Promotion_img2', 'webp'),
      //   text: t('promotion.summer_sales'),
      //   time: '22.05.2023',
      //   content_title: translationHK?.promotion?.summer_sales
      // },
    ]
    // const PromotionTopList = [PromotionList[0], PromotionList[1]]
    // const PromotionbottomList = [...PromotionList].slice(2)

    return (
      <Box>
        <Box
          // display="flex"
          // flexWrap="wrap"
          margin="0 auto"
        >
          {PromotionList?.map((item, index) => (
            <Box
              width="48%"
              // width="100%"
              key={index}
              className={classes.PromotionContainer}
              margin="0 1%"
              onClick={() => {
                articleClick('EH_Promo_Article', 'EH_Promo_Article', item?.content_title, item.path)
                history.push(item.path)
              }}
            >
              <Box>
                <img width="100%" src={item.promotionSrc} alt="Promotion img" className={classes.imgstyle} />
              </Box>
              <Box className={classes.PromotionBox}>
                <Suona />
                <Box mt={0.1} ml={0.5}>
                  {t('glossary. promotion_discount')}
                </Box>
              </Box>
              <Box className={classes.PromotionTitle} fontSize={18}>
                {item.text}
              </Box>
              <Box className={classes.PromotionTime}>{item.time}</Box>
            </Box>
          ))}
        </Box>
        {/* <Box display="flex" flexWrap="wrap" justifyContent="center">
          {PromotionbottomList?.map((item, index) => (
            <Box
              width="32%"
              key={index}
              className={classes.PromotionContainer}
              margin="0 0.5%"
              onClick={() => {
                history.push(item.path)
              }}
            >
              <Box>
                <img width="100%" src={item.promotionSrc} alt="Promotion img" />
              </Box>
              <Box className={classes.PromotionBox}>
                <Suona />
                <Box mt={0.1} ml={0.5}>
                  {t('glossary. promotion_discount')}
                </Box>
              </Box>
              <Box className={classes.PromotionTitle} fontSize={18}>
                {item.text}
              </Box>
              <Box className={classes.PromotionTime}>{item.time}</Box>
            </Box>
          ))}
        </Box> */}
      </Box>
    )
  }
  return (
    <Box className={classes.root}>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList
              className={classes.tabList}
              onChange={handleChange}
              aria-label="lab API tabs example"
              centered
            >
              <Tab label={t('glossary.all_promotion')} value="1" />
              <Tab label={t('glossary.promotion_use_function')} value="2" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <AllPromotion />
          </TabPanel>
          <TabPanel value="2">
            <Box>
              <Box width="50%" margin="0 auto">
                <PaymentTutorial />
                <Box
                  className={classes.viewAllbtn}
                  onClick={() => {
                    buttonClick('EH_Promo_CodeUsage_Book', 'EH_Promo_CodeUsage_Book')
                    history.push('/ProductList')
                  }}
                >
                  <Box>{t('glossary.promotion.to_order')}</Box>
                  <ViewAllIcon className={classes.viewAllbtnIcon} />
                </Box>
              </Box>
            </Box>
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  )
}

export default Promotion
